module.exports = __webpack_public_path__ + "img/261.17f4a322.png";